import React from "react";
import Slider from "../components/Slider";
import About from "../components/About";
import Pricing from "../components/Pricing";
import FAQ from "../components/FAQ";
import Testimonials from "../components/Testimonials";
import Team from "../components/Team";
import Contact from "../components/Contact";
import Features from "../components/Features";

export default function Home() {
  return (
    <>
      <Slider />
      <Features />
      <About />
      {/* <Pricing /> */}
      <FAQ />
      {/* <Testimonials /> */}
      <Team />
      <Contact />
    </>
  );
}
